














































































































import mixins from 'vue-typed-mixins';
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions';
export default mixins().extend({
  components: {
    EditorContent,
    EditorMenuBar,
  },

  props: {
    value: {
      type: String as () => string,
    },
    label: {
      type: String as () => string,
    },
    disabled: {
      type: Boolean as () => boolean,
    },
    loading: {
      type: Boolean as () => boolean,
    },
    basic: {
      type: Boolean as () => boolean,
    },
    advanced: {
      type: Boolean as () => boolean,
    },
    errorMessages: {
      type: Array as () => string[],
    },
  },

  data(): {
    editor?: Editor;
    linkUrl: String,
    linkMenuIsActive: boolean
  } {
    return {
      editor: undefined,
      linkUrl: "",
      linkMenuIsActive: false,
    };
  },

  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
      ],
      editable: !this.disabled,
      onUpdate: this.update,
    });
  },

  beforeDestroy() {
    this.editor?.destroy();
  },

  watch: {
    value(value: string) {
      if (this.editor?.getHTML() !== value) {
        this.editor?.setContent(value);
      }
    },

    disabled() {
      this.editor?.setOptions({
        editable: !this.disabled,
      });
    },
  },

  methods: {
    showLinkMenu(attrs: any) {
      this.linkUrl = attrs.href
      this.linkMenuIsActive = true
      // this.$nextTick(() => {
      //   this.$refs.linkInput.focus()
      // })
    },
    hideLinkMenu() {
      this.linkUrl = ""
      this.linkMenuIsActive = false
    },
    setLinkUrl(command : any, url: String) {
      command({ href: url })
      this.hideLinkMenu()
    },
    update(editor: any) {
      const json = this.editor?.getJSON();
      if (json.content.some((row: any) => !!row.content)) {
        this.$emit('input', editor.getHTML());
      } else {
        this.$emit('input', null);
      }
    },
  },
});
